export interface User {
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    role: UserRole;
    /**
     * Administrator authority as decided by the API (roles.is_admin, migration
     * 071) — never inferred from the role name. Optional only so sessions saved
     * before this field existed still parse; they are refreshed from /auth/me.
     */
    isAdmin?: boolean;
    department?: string;
    avatar?: string;
    createdDate: Date;
    lastLogin?: Date;
    isActive: boolean;
}

export enum UserRole {
    Admin = 'admin',
    Manager = 'manager',
    User = 'user',
    Viewer = 'viewer'
}

export interface LoginRequest {
    username: string;
    password: string;
}

export interface RegisterRequest {
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    department?: string;
}

export interface AuthResponse {
    user: User;
    token: string;
    expiresIn: number;
}

/** Returned by POST /auth/login when the emailed OTP is still needed. */
export interface LoginOtpChallenge {
    otpRequired: true;
    otpToken: string;
    maskedEmail: string;
    expiresIn: number; // seconds the OTP stays valid
    resendIn: number;  // seconds until "Resend OTP" is allowed
}

export interface LoginOtpResend {
    message: string;
    maskedEmail: string;
    expiresIn: number;
    resendIn: number;
}

export interface UserPrivilege {
    name: string;
    module: string;
}

export interface AuthState {
    isAuthenticated: boolean;
    user: User | null;
    token: string | null;
    privileges?: UserPrivilege[];
}
